module.exports = __webpack_public_path__ + "img/zMu_ico_ascolto.a4d4c653.svg";